import {IconInfoCircleInline, IconInfoCircleInlineFilled} from '@sdox/icons/inline'
import {onButtonKeyEvent, twMerge} from '@sdox/utils'

import {useDisclaimerDialogStore} from '../../stores'

import type {ComponentProps} from 'react'

export interface FootnoteProps extends ComponentProps<'span'> {
  identifier: string
}

export const Footnote = (props: FootnoteProps) => {
  const {children, className, identifier, ...restProps} = props
  const setActiveId = useDisclaimerDialogStore(state => state.setActiveId)

  // size, min-w, max-w, min-h max-h are not yet documented in Figma but were approved by @Steffen Schäfer
  // ml-spacing-2 is not really needed for the current implementation with position:absolute but
  //  we will keep it for clarity since it is specified in design.
  const iconClassName = [
    'ml-spacing-2 align-text-top',
    'size-[0.75em] min-w-spacing-10 max-w-spacing-28 min-h-[11px] max-h-[31px]',
  ]

  return (
    <span
      data-testid={'_footnote'}
      data-identifier={identifier}
      className={twMerge(className, 'relative')}
      {...restProps}
    >
      {/* Add padding-right that matches the width of the icon */}
      {/* The icon has a width of 0.75em, min 10px, max 28px */}
      {/* The icon also has a margin-left of 2 pixel, which we could remove on the icon itself but */}
      {/* we will keep this for clarity that we know that we have to add it here. */}
      <span className={'pr-[clamp(12px,calc(0.75em+2px),30px)]'}>
        {children}
      </span>
      <span
        role={'button'}
        tabIndex={0}
        onClick={(event) => {
          event.stopPropagation()
          setActiveId(identifier)
        }}
        onKeyDown={onButtonKeyEvent((event) => {
          event.stopPropagation()
          setActiveId(identifier)
        })}
        title={'Fußnote anzeigen'}
        aria-label={'Fußnote anzeigen'}
        className={'group absolute bottom-0 right-0'}
      >
        <IconInfoCircleInline
          className={twMerge(
            iconClassName,
            'inline-block group-hover:hidden',
          )}
        />
        <IconInfoCircleInlineFilled
          className={twMerge(
            iconClassName,
            'hidden group-hover:inline-block',
          )}
        />
      </span>
    </span>
  )
}
